// extracted by mini-css-extract-plugin
module.exports = {"container":"List__container--3Ty87","list":"List__list--10zvG"};